import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// TODO Changer le redirectTo pour que ça aille sur la page d'accueil
const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', loadChildren: () => import('./pages/login-pages/login.module').then(m => m.LoginModule) },
  { path: 'user', loadChildren: () => import('./pages/user/user-root.module').then(m => m.UserRootModule) },
  { path: 'administration', loadChildren: () => import('./pages/administration/administration.module').then(m => m.AdministrationModule) },
  { path: 'stellair', loadChildren: () => import('./pages/stellair/callback-page/callback-page.module').then(m => m.CallbackPageModule) },
  { path: 'export-patient/download', loadChildren: () => import('./pages/export-patient-download/export-patient-download.module').then(m => m.ExportPatientDownloadModule) },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
